/**
 * Shared ATS match score / status display helpers (consistent across Matches, JobDetails, CandidateDetails).
 */

import React from 'react';

export function getMatchScoreTone(score) {
  const n = Number(score);
  if (Number.isNaN(n)) return 'secondary';
  if (n >= 80) return 'success';
  if (n >= 60) return 'info';
  if (n >= 40) return 'warning';
  return 'danger';
}

export function getMatchStatusTone(status) {
  switch (String(status || '').toLowerCase()) {
    case 'shortlisted':
      return 'success';
    case 'reviewed':
      return 'info';
    case 'rejected':
      return 'danger';
    case 'pending':
      return 'secondary';
    default:
      return 'secondary';
  }
}

/** Score bands for grouping — aligned with getMatchScoreTone thresholds. */
export function getMatchScoreBand(score) {
  const n = Number(score) || 0;
  if (n >= 80) return 'high';
  if (n >= 60) return 'good';
  if (n >= 40) return 'fair';
  return 'low';
}

export const MATCH_SCORE_BAND_LABELS = {
  high: 'High match (80%+)',
  good: 'Good match (60–79%)',
  fair: 'Fair match (40–59%)',
  low: 'Low match (<40%)',
};

export function MatchScoreBadge({ score, suffix = '%' }) {
  const tone = getMatchScoreTone(score);
  const display = score == null || score === '' ? '—' : `${Math.round(Number(score))}${suffix}`;
  return <span className={`badge badge-${tone} match-score-badge`}>{display}</span>;
}

export function MatchStatusBadge({ status }) {
  const label = status || 'pending';
  return (
    <span className={`badge badge-${getMatchStatusTone(label)} match-status-badge`}>
      {label}
    </span>
  );
}
